import axios from 'axios'

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
})

const formatAuthorization = (idToken) =>
  idToken + '.' + btoa(JSON.stringify({ id: process.env.REACT_APP_ID }))

export default {
  getReportData: (idToken) =>
    new Promise((resolve, reject) => {
      console.debug(process.env.REACT_APP_API_URL)
      instance
        .post(
          'reports/data',
          {
            init: true,
          },
          {
            headers: {
              Authorization: formatAuthorization(idToken),
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(new Error("Couldn't retrieve data"))
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),

  searchData: (idToken, params) =>
    new Promise((resolve, reject) => {
      console.debug(process.env.REACT_APP_API_URL)
      instance
        .post(
          'reports/data',
          {
            search: true,
            to: params.toDate,
            from: params.fromDate,
          },
          {
            headers: {
              Authorization: formatAuthorization(idToken),
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(new Error("Couldn't retrieve data"))
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
    getCustomerSuccess: (idToken) =>
    new Promise((resolve, reject) => {
      console.debug(process.env.REACT_APP_API_URL)
      instance
        .post(
          'reports/customer',
          {
            init: true,
          },
          {
            headers: {
              Authorization: formatAuthorization(idToken),
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(new Error("Couldn't retrieve data"))
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
    searchCustomerSuccess: (idToken, params) =>
    new Promise((resolve, reject) => {
      console.debug(process.env.REACT_APP_API_URL)
      instance
        .post(
          'reports/customer',
          {
            search: true,
            to: params.toDate,
            from: params.fromDate,
            name:params.name,
            company:params.company,
          },
          {
            headers: {
              Authorization: formatAuthorization(idToken),
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(new Error("Couldn't retrieve data"))
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),

    searchDataManagement: (idToken, params) =>
    new Promise((resolve, reject) => {
      console.debug(process.env.REACT_APP_API_URL)
      instance
        .post(
          'reports/data-manager',
          {
            search: true,
            sellOrder: params
          },
          {
            headers: {
              Authorization: formatAuthorization(idToken),
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          } else {
            reject(new Error("Couldn't retrieve data"))
          }
        })
        .catch((error) => {
          reject(error)
        })
    }),
}
